

export let tableSelect = () => {
    $(".team-query__row--leadership").click(function() {
        window.location = $(this).data("url");
    });
}

export let dataTables = () => {
    $(".team-query__table, .transactions-query__table").DataTable({
        paging: true,
        pagingType: 'simple_numbers',
        pageLength: 50,
        searching: true,
        ordering: true,
        info: true,
        order: [],
        autoWidth: false,
        lengthChange: true,
        responsive: true,
        dom: '<"tabledata-top"lf><"tabledata-body"t><"tabledata-bottom"irpB>',
        language: {
            search: '',
            lengthMenu: '_MENU_',
            paginate: {
                previous: 'Previous',
                next: 'Next'
            }
        },
        lengthMenu: [
            [10, 25, 50, 100], // Values 
            ['View - 10', 'View - 25', 'View - 50', 'View - 100'] // Displayed
        ]
    });

    $('.dt-search input').attr('placeholder', 'Search...');
}